// src/components/Regularize.js
import React, { useEffect, useState } from "react";
import { EssDasbaord } from "../../../api/Ess/Essleaves";
import Swal from "sweetalert2"; // Import SweetAlert2 for confirmation dialogs
import { FaEye } from "react-icons/fa";
import Select from "react-select";
const Regularize = () => {
  const [empData, setEmpData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
 const [monthFilter, setMonthFilter] = useState(() => {
  const currentDate = new Date();
  return currentDate.toISOString().slice(0, 7); // "YYYY-MM"
});

  const [rejectModal, setRejectModal] = useState({
    show: false,
    id: null,
    reason: "",
  });



  const [selectedStatus ,setSelectedStatus] = useState({ value: "Pending", label: "Pending" });


  const statusOptions = [
    { value: "Pending", label: "Pending" },
    { value: "Approved", label: "Approved" },
    { value: "Rejected", label: "Rejected" },
  ];

  const user = JSON.parse(localStorage.getItem("school_user"));
  const school_id = user?.user_detail?.fk_school_id;

  const getEmployeesData = async (s= searchTerm, m= monthFilter ,status=selectedStatus) => {
    let data = {
      school_id: school_id,
      search_name: s,
      monthFilter: m,
      isApproved: status?.value
    };

    try {
      const response = await EssDasbaord.get_all_reguralize(data);
      const Res = response.data.data;
      console.log(Res, "Res");
      setEmpData(Res);
    } catch (error) {
      console.error("Error fetching applied leaves:", error);
    }
  };

  useEffect(() => {
    getEmployeesData();
  }, []);

  // Handle Approval
  const handleApprove = async (id) => {
    try {
      let data = {
        request_id: id,
        school_id: school_id,
        isApproved: true,
      };
      const response = await EssDasbaord.approve_regularize(data);
      const res = response.data;
      if (res.status === 200) {
        // Update the request status locally
        getEmployeesData();

        Swal.fire("Approved!", "The request has been approved.", "success");
      } else {
        Swal.fire(
          "Error",
          "There was an issue approving the request.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error approving request:", error);
    }
  };

  // Handle Rejection with confirmation
  const handleReject = (id) => {
    Swal.fire({
      title: "Are you sure you want to reject this request?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.isConfirmed) {
        setRejectModal({ show: true, id, reason: "" });
      }
    });
  };

  // Confirm rejection after entering reason
  const confirmReject = async () => {
    const { id, reason } = rejectModal;
    if (!reason.trim()) {
      Swal.fire("Error", "Please provide a rejection reason.", "error");
      return;
    }

    let data = {
      request_id: id,
      school_id: school_id, // Replace with actual school ID
      rejection_reason: reason,
      isApproved: false,
    };

    try {
      const response = await EssDasbaord.reject_regularize(data);
      const res = response.data;
      if (res.status === 200) {
        // Update the request status locally
        setRejectModal({ show: false, id: null, reason: "" });
        Swal.fire("Rejected!", "The request has been rejected.", "success");
        getEmployeesData();
      } else {
        Swal.fire(
          "Error",
          "There was an issue rejecting the request.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error rejecting request:", error);
      Swal.fire("Error", "There was an issue rejecting the request.", "error");
    }
  };

  // Filtering employee requests based on search term and month

  console.log(empData, "filteredRequests");

  const getStatusBadge = (status) => {
    switch (status) {
      case "APPROVED":
        return <span className="badge bg-success">{status}</span>;
      case "REJECTED":
        return <span className="badge bg-danger">{status}</span>;
      case "PENDING":
        return <span className="badge bg-warning ">{status}</span>;
      default:
        return <span className="badge bg-secondary">{status}</span>;
    }
  };

  return (
    <div className="container py-4">
      <h4 className="page-title mb-3">Regularization Request</h4>

      {/* Filters */}
    <div className="card shadow-sm p-3 mb-4">
  <div className="row g-3 align-items-end">
    
    {/* Search Employee */}
    <div className="col-md-3">
      <label className="form-label fw-semibold">Search Employee</label>
      <input
        type="text"
        placeholder="Search Employee here"
        className="form-control"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>

    {/* Month Picker */}
    <div className="col-md-3">
      <label className="form-label fw-semibold">Select Month-Year</label>
      <input
        type="month"
        className="form-control"
        value={monthFilter}
        onChange={(e) => setMonthFilter(e.target.value)}
      />
    </div>

    {/* Status Dropdown */}
    <div className="col-md-3">
      <label className="form-label fw-semibold">Status</label>
      <Select
        options={statusOptions}
        value={selectedStatus}
        onChange={(option) => setSelectedStatus(option)}
        className="basic-single"
        classNamePrefix="select"
      />
    </div>

    {/* View Button */}
    <div className="col-md-3">
      <button
        className="btn btn-outline-secondary "
        onClick={() => getEmployeesData(searchTerm, monthFilter)}
      >
        <FaEye className="me-1" /> View
      </button>
    </div>

  </div>
</div>


      {/* Employee Requests */}
      <div className="row">
        {empData?.length > 0 ? (
          empData?.map((req) => (
            <div className="col-md-6 mb-4" key={req.id}>
              <div className="card shadow-sm h-100">
                <div className="card-body position-relative">
                  <h6 className="fw-bold mb-2">
                    {req.staff_name} {getStatusBadge(req.is_approved)}
                  </h6>
                  <p className="mb-2">
                    <strong>Date:</strong>{" "}
                    {new Date(req.date).toLocaleDateString("en-GB")}
                  </p>
                  <div className="mb-2">
                    <span className="badge bg-success">
                      In: {req.requestedIn}
                    </span>
                    <span className="badge bg-warning mx-1">
                      Out: {req.requestedOut}
                    </span>
                  </div>
                  {req.is_approved === "Rejected" && (
                    <p className="mb-0">
                      <strong>Remarks:</strong> {req.remarks}
                    </p>
                  )}

                  {/* Action buttons */}
                  {req.is_approved === "Pending" && (
                    <div className="mt-3">
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleApprove(req.id)}
                      >
                        Approve
                      </button>
                      <button
                        className="btn btn-sm btn-danger mx-1"
                        onClick={() => handleReject(req.id)}
                      >
                        Reject
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p className="text-muted">No requests found</p>
        )}
      </div>

      {/* Reject Modal */}
      {rejectModal.show && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Reject Request</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() =>
                    setRejectModal({ show: false, id: null, reason: "" })
                  }
                ></button>
              </div>
              <div className="modal-body">
                <label className="form-label">Reason for rejection</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={rejectModal.reason}
                  onChange={(e) =>
                    setRejectModal((prev) => ({
                      ...prev,
                      reason: e.target.value,
                    }))
                  }
                ></textarea>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() =>
                    setRejectModal({ show: false, id: null, reason: "" })
                  }
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={confirmReject}
                  disabled={!rejectModal.reason.trim()}
                >
                  Confirm Reject
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Regularize;
